module.exports = __webpack_public_path__ + "static/media/usuario.7cce6916.svg";